import angular from 'angular';
import fullBetName from './fullBetNameFilter';

// this is an old module that is deprecated
const moduleName = angular.module('ngLib', [])
  .filter('fullBetName', fullBetName)
  .name;

export default moduleName;
